import { useQuery } from '@tanstack/react-query';
import State from '../api/Laws';

export const useGetLaws = (id, options) =>
  useQuery({
    queryKey: ['getLaws'],
    queryFn: async () => {
      const response = await State.fetchStateLaws(id);
      return response;
    },
    enabled: options?.enabled ?? true,
  });
